<template>
  <div id="contenedor-main-ejecuccion-configuracion">
    <AuditoriaContratos
    v-show="false"
    ref="auditoriaContratos"
    :listadoContratos="getContratos" />
    <v-container
      fluid>
      <v-card
        flat>
        <v-card-text>
          <titulo-tool-bar
            titulo="Configuración">
            <template v-slot:opciones-derecha>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="$refs.auditoriaContratos.abrirAuditoriaContratos()">
                    <v-icon> mdi-file-document-check-outline </v-icon>
                  </v-btn>
                </template>
                <span> Auditoria Contratos </span>
              </v-tooltip>
            </template>
          </titulo-tool-bar>
          <opciones-tool-bar></opciones-tool-bar>
        </v-card-text>
      </v-card>
    </v-container>
    <router-view></router-view>
  </div>
</template>

<script>
import CONTRATOS from '@/graphql/querys/administracion/contratos/contratos.gql';
import TituloToolBar from '@/components/TituloToolBar.vue';
import OpcionesToolBar from './OpcionesToolBar.vue';
import AuditoriaContratos from '@/components/administracion/contratos/auditoria/ContratosAuditoria.vue';

export default {
  name: 'MainEjecuccionConfiguracion',
  components: {
    TituloToolBar,
    OpcionesToolBar,
    AuditoriaContratos,
  },
  data() {
    return {};
  },
  apollo: {
    contratos: {
      query: CONTRATOS,
    },
  },
  computed: {
    getContratos() {
      if (!this.contratos) return [];
      return this.contratos;
    },
  },
};
</script>

<style lang="scss">

</style>
